var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"id":"alerts","fluid":"","tag":"section"}},[_c('base-v-component',{attrs:{"heading":"Alerts","link":"components/alerts"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }